<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/miximo/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{ $t("hello") }}</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_Mix}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_Mix}}</h2>
            </div>  
            <div class="inputWrap"  v-if="countryCode !== 'fi' && gateway_Mix !== 'nth'">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_Mix}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="auth_Mix === 'loggedin'">
            <div v-if="is_unsub_Mix != '0'">
              <a @click="logout_Mix(is_unsub_Mix)" style="text-decoration:none; color: white" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
            <div v-else-if="countryCode === 'fi' && gateway_Mix === 'nth'">
            </div>
            <div v-else>
              <a @click="logout_Mix(is_unsub_Mix)" href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_Mix",
    "renew_date_Mix",
    "subscription_date_Mix",
    "auth_Mix",
    "is_unsub_Mix",
    "countryCode",
    "gateway_Mix"
  ]),
  methods: {
    ...mapActions(["logout_Mix"]),
    logout(is_unsub) {
      // localStorage.clear();
      axios.post(`http://api.puretechglobal.net/gateway_request/bahrain/actel/unsub.php?code=28wpx48x4&msisdn=973234567`).then(res=>{
        console.log(res)
      });
      //router.push({name: Login}).catch(err => {})
    }
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/miximo/Profile.vue